import { FileTextIcon } from "@lucide/icons";

import { Icon } from "simplydo/react/ui/icon";

import IdeaPdfExport from "components/lib/IdeaPdfExport";
import { TooltipButton } from "components/lib/UI";

import type { IdeaWithOwnerChallenge } from "../types";

type DownloadPDFActionProps = { idea: IdeaWithOwnerChallenge };

const DownloadPDFAction = ({ idea }: DownloadPDFActionProps) => {
  return (
    <IdeaPdfExport
      ideas={[idea]}
      challenge={idea?.ownerChallenge}
      popupOffset={[0, -7]}
      hidePopup
      trigger={
        <TooltipButton tooltip="Download PDF">
          <Icon icon={FileTextIcon} />
        </TooltipButton>
      }
    />
  );
};

export default DownloadPDFAction;
